var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{attrs:{"value":_vm.value,"min":"0","max":"100","outlined":"","type":"number","step":"0.000001","label":_vm.label,"suffix":"%","hide-details":_vm.hideDetails},on:{"input":function($event){return _vm.$emit('input', $event)},"blur":_vm.minMax}})
}
var staticRenderFns = []

export { render, staticRenderFns }